import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MatPageable, PageableResponse } from '@core/table/mat-table';

const baseRef = 'mandatos';
const route = {
  combo: (tipo: string) => `${baseRef}/combo/${tipo}`,
  consultar: `${baseRef}/consultar`,
  salvar: `${baseRef}/salvar`,
  editar: (idEntidade: number) => `${baseRef}/atualizar/${idEntidade}`,
  consultarPorEntidade: (idEntidade: number) => `${baseRef}/entidade/${idEntidade}`,
};

@Injectable({
  providedIn: 'root'
})
export class MandatoService {
  constructor(private apiService: ApiService, private http: HttpClient) { }

  salvarMandato(mandato: any): Observable<any> {
    return this.apiService.post<any>(route.salvar, mandato);
  }

  editarMandato = (idEntidade: number, mandato: any): Observable<any> => {
    return this.apiService.put<any>(route.editar(idEntidade), mandato);
  }


  deleteMandato = (id: number): Observable<any> => {
    return this.apiService.delete<any>(`${baseRef}/${id}`);
  }

  consultarMandatoCombo(tipo: string): Observable<any> {
    return this.apiService.get<any>(route.combo(tipo));
  }

  consultar(filtro: any, page: MatPageable) {
    return this.apiService.post<PageableResponse<any>>(`${route.consultar}${page.query}`, this.apiService.removeNullPropertys(filtro));

  }

  consultarPorId(id: number): Observable<any> {
    return this.apiService.get<any>(`${baseRef}/${id}`);
  }

  consultarPorEntidade(idEntidade: number) {
    return this.apiService.get<PageableResponse<any>>(route.consultarPorEntidade(idEntidade));

  }

}
